import { Link } from 'react-router-dom';
import React from 'react';
import videoBg from '../assets/techno.mp4'
import videoUp from '../assets/update.mp4'

const Updates = () => {
  return (
    <div className='updates'>
      <video src = {videoBg} autoPlay loop muted />
            <div className='content'>
                <div className='text'>
                    <Link to="/">
                    <h1 style={{ cursor: 'pointer' }}>Go Back</h1>
                    </Link>
                </div>
                
             <div>
                <video src = {videoUp} autoPlay loop/>
            </div>
        </div>
    </div>
    
  );
};

export default Updates;